// extracted by mini-css-extract-plugin
module.exports = {"container":"AuditLogs_container__188wD"};